import { Editor } from '@tinymce/tinymce-react';
import React from 'react';

export const HtmlEditor = (props) => {
    return (
        <Editor
            apiKey="2kqayg5x2hql7nm7bq1qa7wkyys48k79iefcstq5a5pjyrzb"
            value={props.content}
            init={
                {
                    height: 500,
                    menubar: false,
                    toolbar:
                        "undo redo | formatselect | bold italic backcolor forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link image | help | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
                    image_list: [],
                    language: "fr_FR",
                    placeholder: "Corps de l'article"
                }
            }
            plugins='advlist autolink lists link image charmap print preview anchor textcolor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount link image table'
            {...props}
        />
    )

}